import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Grid from '@material-ui/core/Grid';
import Link from '../../Link/Link';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';
import { GetFirstImageFromBlocks, GetShortDescriptionFromBlocks } from '../../../helpers/BlocksDataHelper';

export const ArticleList = props => {
  const {
    quantity
  } = props;

  const useStyles = makeStyles(theme => ({
    articleImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
    },
    articleImageWrapper: {
      width: '100%',
      height: '100%'
    },
    articleName: { 
      fontSize: '36px',
      marginTop: '-10px'
    },
    articleBlurb: {
      fontSize: '16px'
    }
  }));
  const classes = useStyles();

  return (
    <StaticQuery
      query={graphql`
        {
          allBuilderModels {
            article(limit: 50, options: { cachebust: true }) {
              content
            }
          }
        }
      `}
      render={data => {
        const articles = data?.allBuilderModels?.article || [];
        return (
        <>
          <Grid container spacing={5} className="article-list-row">
            {
              articles.length ? ( articles.slice(0, (quantity || 9)).map((article, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <Link href={article.content?.data?.url || '#'}>
                    <div className="article-list-image">
                      <Skeleton className='lazy-load-image-skeleton' variant="rectangular" />
                      <LazyLoadImage
                        src={GetFirstImageFromBlocks(article.content?.data?.blocks)}
                        effect="opacity"
                        className={classes.articleImage}
                        wrapperClassName={classes.articleImageWrapper}
                      />
                    </div>
                    <div className="article-list-content">
                      <div className="article-name"> { article.content?.name } </div>
                      <div className="content-text" dangerouslySetInnerHTML={{__html: GetShortDescriptionFromBlocks(article.content?.data?.blocks)}}></div>
                    </div>
                  </Link>
                </Grid>
            ))) : <h4>No articles found.</h4>
          }
          </Grid>
        </>
      )}}
    ></StaticQuery>
  );

};